var cov_25hs32fblg = function () {
  var path = "/Users/spana/SHEIN/shineout/src/utils/dom/document.ts",
      hash = "fb0dae19f067fd29d8a95dc28e752e4aee2d8834",
      Function = function () {}.constructor,
      global = new Function('return this')(),
      gcv = "__coverage__",
      coverageData = {
    path: "/Users/spana/SHEIN/shineout/src/utils/dom/document.ts",
    statementMap: {
      "0": {
        start: {
          line: 1,
          column: 25
        },
        end: {
          line: 16,
          column: 1
        }
      },
      "1": {
        start: {
          line: 3,
          column: 4
        },
        end: {
          line: 3,
          column: 72
        }
      },
      "2": {
        start: {
          line: 6,
          column: 4
        },
        end: {
          line: 6,
          column: 74
        }
      },
      "3": {
        start: {
          line: 9,
          column: 4
        },
        end: {
          line: 9,
          column: 46
        }
      },
      "4": {
        start: {
          line: 10,
          column: 4
        },
        end: {
          line: 10,
          column: 35
        }
      },
      "5": {
        start: {
          line: 13,
          column: 4
        },
        end: {
          line: 13,
          column: 47
        }
      },
      "6": {
        start: {
          line: 14,
          column: 4
        },
        end: {
          line: 14,
          column: 36
        }
      },
      "7": {
        start: {
          line: 18,
          column: 23
        },
        end: {
          line: 25,
          column: 1
        }
      },
      "8": {
        start: {
          line: 20,
          column: 4
        },
        end: {
          line: 20,
          column: 76
        }
      },
      "9": {
        start: {
          line: 23,
          column: 4
        },
        end: {
          line: 23,
          column: 78
        }
      },
      "10": {
        start: {
          line: 32,
          column: 2
        },
        end: {
          line: 34,
          column: 3
        }
      },
      "11": {
        start: {
          line: 33,
          column: 4
        },
        end: {
          line: 33,
          column: 50
        }
      },
      "12": {
        start: {
          line: 36,
          column: 2
        },
        end: {
          line: 42,
          column: 3
        }
      },
      "13": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 40,
          column: 7
        }
      },
      "14": {
        start: {
          line: 39,
          column: 8
        },
        end: {
          line: 39,
          column: 49
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 2,
            column: 2
          },
          end: {
            line: 2,
            column: 3
          }
        },
        loc: {
          start: {
            line: 2,
            column: 12
          },
          end: {
            line: 4,
            column: 3
          }
        },
        line: 2
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 5,
            column: 2
          },
          end: {
            line: 5,
            column: 3
          }
        },
        loc: {
          start: {
            line: 5,
            column: 13
          },
          end: {
            line: 7,
            column: 3
          }
        },
        line: 5
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 8,
            column: 2
          },
          end: {
            line: 8,
            column: 3
          }
        },
        loc: {
          start: {
            line: 8,
            column: 17
          },
          end: {
            line: 11,
            column: 3
          }
        },
        line: 8
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 12,
            column: 2
          },
          end: {
            line: 12,
            column: 3
          }
        },
        loc: {
          start: {
            line: 12,
            column: 18
          },
          end: {
            line: 15,
            column: 3
          }
        },
        line: 12
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 19,
            column: 2
          },
          end: {
            line: 19,
            column: 3
          }
        },
        loc: {
          start: {
            line: 19,
            column: 14
          },
          end: {
            line: 21,
            column: 3
          }
        },
        line: 19
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 22,
            column: 2
          },
          end: {
            line: 22,
            column: 3
          }
        },
        loc: {
          start: {
            line: 22,
            column: 15
          },
          end: {
            line: 24,
            column: 3
          }
        },
        line: 22
      },
      "6": {
        name: "addEventListener",
        decl: {
          start: {
            line: 26,
            column: 16
          },
          end: {
            line: 26,
            column: 32
          }
        },
        loc: {
          start: {
            line: 31,
            column: 2
          },
          end: {
            line: 43,
            column: 1
          }
        },
        line: 31
      },
      "7": {
        name: "remove",
        decl: {
          start: {
            line: 37,
            column: 21
          },
          end: {
            line: 37,
            column: 27
          }
        },
        loc: {
          start: {
            line: 37,
            column: 30
          },
          end: {
            line: 41,
            column: 5
          }
        },
        line: 37
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 3,
            column: 11
          },
          end: {
            line: 3,
            column: 45
          }
        }, {
          start: {
            line: 3,
            column: 49
          },
          end: {
            line: 3,
            column: 72
          }
        }],
        line: 3
      },
      "1": {
        loc: {
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 74
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 6,
            column: 11
          },
          end: {
            line: 6,
            column: 46
          }
        }, {
          start: {
            line: 6,
            column: 50
          },
          end: {
            line: 6,
            column: 74
          }
        }],
        line: 6
      },
      "2": {
        loc: {
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 76
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 20,
            column: 11
          },
          end: {
            line: 20,
            column: 47
          }
        }, {
          start: {
            line: 20,
            column: 51
          },
          end: {
            line: 20,
            column: 76
          }
        }],
        line: 20
      },
      "3": {
        loc: {
          start: {
            line: 23,
            column: 11
          },
          end: {
            line: 23,
            column: 78
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 23,
            column: 11
          },
          end: {
            line: 23,
            column: 48
          }
        }, {
          start: {
            line: 23,
            column: 52
          },
          end: {
            line: 23,
            column: 78
          }
        }],
        line: 23
      },
      "4": {
        loc: {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        }, {
          start: {
            line: 32,
            column: 2
          },
          end: {
            line: 34,
            column: 3
          }
        }],
        line: 32
      },
      "5": {
        loc: {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        }, {
          start: {
            line: 38,
            column: 6
          },
          end: {
            line: 40,
            column: 7
          }
        }],
        line: 38
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0]
    },
    _coverageSchema: "43e27e138ebf9cfc5966b082cf9a028302ed4184"
  },
      coverage = global[gcv] || (global[gcv] = {});

  if (coverage[path] && coverage[path].hash === hash) {
    return coverage[path];
  }

  coverageData.hash = hash;
  return coverage[path] = coverageData;
}();

export var docScroll = (cov_25hs32fblg.s[0]++, {
  get top() {
    cov_25hs32fblg.f[0]++;
    cov_25hs32fblg.s[1]++;
    return (cov_25hs32fblg.b[0][0]++, document.documentElement.scrollTop) || (cov_25hs32fblg.b[0][1]++, document.body.scrollTop);
  },

  get left() {
    cov_25hs32fblg.f[1]++;
    cov_25hs32fblg.s[2]++;
    return (cov_25hs32fblg.b[1][0]++, document.documentElement.scrollLeft) || (cov_25hs32fblg.b[1][1]++, document.body.scrollLeft);
  },

  set top(value) {
    cov_25hs32fblg.f[2]++;
    cov_25hs32fblg.s[3]++;
    document.documentElement.scrollTop = value;
    cov_25hs32fblg.s[4]++;
    document.body.scrollTop = value;
  },

  set left(value) {
    cov_25hs32fblg.f[3]++;
    cov_25hs32fblg.s[5]++;
    document.documentElement.scrollLeft = value;
    cov_25hs32fblg.s[6]++;
    document.body.scrollLeft = value;
  }

});
export var docSize = (cov_25hs32fblg.s[7]++, {
  get width() {
    cov_25hs32fblg.f[4]++;
    cov_25hs32fblg.s[8]++;
    return (cov_25hs32fblg.b[2][0]++, document.documentElement.clientWidth) || (cov_25hs32fblg.b[2][1]++, document.body.clientWidth);
  },

  get height() {
    cov_25hs32fblg.f[5]++;
    cov_25hs32fblg.s[9]++;
    return (cov_25hs32fblg.b[3][0]++, document.documentElement.clientHeight) || (cov_25hs32fblg.b[3][1]++, document.body.clientHeight);
  }

});
export function addEventListener(target, eventType, cb, option) {
  cov_25hs32fblg.f[6]++;
  cov_25hs32fblg.s[10]++;

  if (target.addEventListener) {
    cov_25hs32fblg.b[4][0]++;
    cov_25hs32fblg.s[11]++;
    target.addEventListener(eventType, cb, option);
  } else {
    cov_25hs32fblg.b[4][1]++;
  }

  cov_25hs32fblg.s[12]++;
  return {
    remove: function remove() {
      cov_25hs32fblg.f[7]++;
      cov_25hs32fblg.s[13]++;

      if (target.removeEventListener) {
        cov_25hs32fblg.b[5][0]++;
        cov_25hs32fblg.s[14]++;
        target.removeEventListener(eventType, cb);
      } else {
        cov_25hs32fblg.b[5][1]++;
      }
    }
  };
}